import { render, staticRenderFns } from "./TXMap.vue?vue&type=template&id=33ace916&scoped=true&"
import script from "./TXMap.vue?vue&type=script&lang=js&"
export * from "./TXMap.vue?vue&type=script&lang=js&"
import style0 from "./TXMap.vue?vue&type=style&index=0&id=33ace916&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ace916",
  null
  
)

export default component.exports